<template>
  <div
    class="card__wrapper"
    :class="{ 'is--selected': isJourneySelected, 'not--selected': !isJourneySelected }"
  >
    <div class="check__wrapper flex align-center relative">
      <v-checkbox v-if="journeyStatus !== 'Cancelada'"  v-model="isJourneySelected" />
      <SmartP class="mr-4 paragraph">{{ journeyDay }}</SmartP>
    </div>
    <div class="flex justify-center">
      <SmartTitle heading="2" weight="medium">{{ journeyDate }}</SmartTitle>
    </div>
    <div>
      <div class="flex align-center">
        <div
          class="aux__wrapper"
          :class="{
            manual: journeyStatus === 'Manual',
            journey: journeyStatus === 'Jornada',
            cancelled: journeyStatus === 'Cancelada',
            editted: journeyStatus === 'Editada',
          }"
        />
        <SmartP class="p__small">{{ journeyStatus }}</SmartP>
      </div>

      <div class="flex align-center">
        <div v-if="dataInfo.cover_sheet_emitted" class="aux__wrapper emmited" />
        <SmartP class="p__small" v-if="dataInfo.cover_sheet_emitted">Emitida</SmartP>

        <div v-if="!dataInfo.cover_sheet_emitted" class="aux__wrapper not--emmited" />
        <SmartP class="p__small" v-if="dataInfo.cover_sheet_emitted === false">Não Emitida</SmartP>
      </div>
    </div>

    <VDivider class="w-full mb-2" />
    <div class="w-full">
      <SmartButton
        @click="openDetails"
        :loading="isLoadingDetails"
        class="flex align-center justify-center w-full"
        quaternary
        icon
      >
        Detalhes
        <SmartIcon type="small" name="arrow_right" />
      </SmartButton>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    isAllJourniesSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isJourneySelected: false,
      isLoadingDetails: false
    };
  },
  watch: {
    isAllJourniesSelected(value) {
      if (value) {
        this.isJourneySelected = true;
        return;
      }
      this.isJourneySelected = false;
    },
    isJourneySelected(value) {
      if (!value && this.isAllJourniesSelected === true) {
        this.$emit('uncheck-selecteds');
      }
      this.$emit('handler-selections', {
        value,
        journey_id: this.dataInfo.id,
        journey_status: this.dataInfo.journey_status
      });
    }
  },
  computed: {
    journeyDay() {
      const journeyDate = this.dataInfo.journey_date;
      moment.locale('pt-br');
      return moment(journeyDate).format('dddd');
    },
    journeyDate() {
      const journeyDate = this.dataInfo.journey_date;
      const date = moment(journeyDate).format('ll');
      const replacedDate = date.replaceAll('de', '');

      return replacedDate;
    },
    journeyStatus() {
      switch (this.dataInfo.journey_status) {
      case 'MANUAL':
        return 'Manual';

      case 'CANCELLED':
        return 'Cancelada';

      case 'EDITTED':
        return 'Editada';

      default: {
        return 'Jornada';
      }
      }
    }
  },
  methods: {
    ...mapActions({
      fetchJourneyById: 'journey/fetchJourneyById'
    }),
    async openDetails() {
      this.isLoadingDetails = true;
      await this.fetchJourneyById(this.dataInfo.id)
        .then(({ data }) => {
          const journeyStatus = this.dataInfo.journey_status;
          const details = {
            ...data,
            journeyStatus

          };
          this.$emit('open-details', details);
        })
        .finally(() => {
          this.isLoadingDetails = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.card__wrapper {
  width: 191px;
  border-radius: 6px;
  padding: 10px 20px 10px 20px;

  border: 1px solid rgba(151, 151, 151, 0.25);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
}

.paragraph {
  color: #000;
  font-size: 10px;
}

.p__small {
  font-size: 10px;
}

.not--selected {
  transition: 0.3s;
  border-left: 7px solid #e3e5e6;
}

.is--selected {
  transition: 0.5s;
  border-left: 7px solid #82c85a;
}

.check__wrapper {
  max-height: 30px;
}

.checkbox {
  width: 10px;
  height: 10px;
  appearance: none;
  outline: 2px solid #979797;
  &:checked {
    background: $color-brand-secondary;
  }
}

.aux__wrapper {
  appearance: none;
}

.card__wrapper {
  height: auto !important;
}
.manual {
  outline: 2px solid #a80d90;
}
.emmited {
  outline: 2px solid #82c85a;
}
.not--emmited {
  outline: 2px solid #919699;
}
.edited {
  outline: 2px solid #f3a72e;
}
.journey {
  outline: 2px solid #2686e5;
}
.cancelled {
  outline: 2px solid #EAD3DF;
}
</style>
